import React from 'react';

import { useSelector } from 'react-redux';

import AlertIcon from 'assets/myAppointments/alert.svg';
import CalendarIcon from 'assets/myAppointments/calendar.svg';
import ClockIcon from 'assets/myAppointments/clock.svg';
import { selectStatistics } from 'features/myAppointments/MyAppointmentsSlice';

import {
  CardsGrid,
  IconWrapper,
  MainTitle,
  OverviewContainer,
  StatCard,
  StatInfo,
  StatLabel,
  StatValue,
  StatusDot,
  SubTitle,
  TitleContainer,
} from './OverviewSection.styles';

const OverviewSection = () => {
  const statistics = useSelector(selectStatistics);
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <OverviewContainer>
      <TitleContainer>
        <MainTitle>My Appointments</MainTitle>
        <SubTitle>{today}</SubTitle>
      </TitleContainer>

      <CardsGrid>
        <StatCard
          $gradient={'linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 50%, #FAF5FF 100%)'}
          $borderColor={'#BEDBFF99'}
        >
          <IconWrapper $src={CalendarIcon} $iconColor={'#2d6cdf'} />
          <StatusDot $dotColor={'#2d6cdf'} />
          <StatInfo>
            <StatLabel>{"Today's Appointments"}</StatLabel>
            <StatValue>{statistics?.todayCount}</StatValue>
          </StatInfo>
        </StatCard>

        <StatCard
          $gradient={'linear-gradient(135deg, #FEF2F2 0%, #FFF1F2 50%, #FDF2F8 100%)'}
          $borderColor={'#FFC9C999'}
        >
          <IconWrapper $src={AlertIcon} $iconColor={'#fb2c36'} />
          <StatusDot $dotColor={'#fb2c36'} />
          <StatInfo>
            <StatLabel>{'Overdue Appointment Count'}</StatLabel>
            <StatValue>{statistics?.overdueCount}</StatValue>
          </StatInfo>
        </StatCard>

        <StatCard
          $gradient={'linear-gradient(135deg, #ECFDF5 0%, #F0FDFA 50%, #ECFEFF 100%)'}
          $borderColor={'#A4F4CF99'}
        >
          <IconWrapper $src={ClockIcon} $iconColor={'#00bc7d'} />
          <StatusDot $dotColor={'#00bc7d'} />
          <StatInfo>
            <StatLabel>{'Upcoming Appointments'}</StatLabel>
            <StatValue>{statistics.upcomingCount}</StatValue>
          </StatInfo>
        </StatCard>
      </CardsGrid>
    </OverviewContainer>
  );
};

export default OverviewSection;
